export { ToggleColor, ToggleComponent, ToggleSize } from './toggle.component';

// FIXME: T63333 Remove ToggleComponent
